import { ArticleParagraph1, ArticleParagraph2, Button, Checkbox, Input } from '@cian/ui-kit';
import { TextButton, Countdown, AgreementBlock } from 'shared/components';

import s from './styles.css';
import { dispatchWidgetEvent, EAnalyticsEventType, EAuthWidgetEventName } from '../../../utils/dispatchWidgetEvent';
import React from 'react';

const CONSENT_TO_ADVERTISING_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/documents/soglasie_na_poluchenie_reklami.pdf';

interface SmsWindowProps {
  uuid: string;
  phone: string;
  code: string;
  codeError: boolean;
  agreementsChecked: boolean;
  setCodeError(v: boolean): void;
  setAgreementsChecked(v: boolean): void;
  onEnterCode(code: string): void;
  setCode(code: string): void;
  onResetPhone(): void;
  onResendPhone(): void;
  onShowAgreements(): void;
}

export function SmsWindow({
  uuid,
  phone,
  codeError,
  setCodeError,
  onEnterCode,
  onResetPhone,
  onResendPhone,
  agreementsChecked,
  setAgreementsChecked,
  code,
  setCode,
}: SmsWindowProps) {
  const handleResendCodeWithAnalytics = (event: React.MouseEvent<HTMLButtonElement>) => {
    onResendPhone();
    dispatchWidgetEvent(event.target, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onCodeScreenResend);
  };

  const handleChangeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCodeError(false);
    setCode(e.target.value);
  };

  const handleConfirmCodeWithAnalytics = (event: React.MouseEvent<HTMLButtonElement>) => {
    onEnterCode(code);
    dispatchWidgetEvent(event.target, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onCodeScreenConfirm);
  };

  const label = (
    <ArticleParagraph2>
      Соглашаюсь{' '}
      <a href={CONSENT_TO_ADVERTISING_URL} target="_blank" className={s.link} rel="noreferrer">
        получать рекламу
      </a>
    </ArticleParagraph2>
  ) as unknown as string;

  return (
    <div>
      <div className={s.message}>
        <ArticleParagraph1>
          Отправили его на <strong>{phone}</strong>
        </ArticleParagraph1>
      </div>
      <div className={s['reset-phone-button']}>
        <TextButton onClick={onResetPhone}>Изменить номер</TextButton>
      </div>
      <Input maxWidth={124} onChange={handleChangeCode} value={code} size="M" placeholder="Код" />
      <p className={s['code-error']}>{codeError && 'Неправильный код'}</p>
      <Countdown key={uuid} onResendPhone={handleResendCodeWithAnalytics} />
      <div className={s['agreements-block']}>
        <Checkbox checked={agreementsChecked} label={label} onChange={() => setAgreementsChecked(!agreementsChecked)} />
        <AgreementBlock />
      </div>
      <Button disabled={code.length !== 4} onClick={e => handleConfirmCodeWithAnalytics(e)}>
        Подтвердить
      </Button>
    </div>
  );
}
